async function asyncMap(array: any[], fn: (arg: any, index?: number) => any) {
  const result = [];

  for (const item of array) {
    result.push(await fn(item));
  }

  return result;
}

export { asyncMap };
